<template>
<div class="wrapper" style="height: 1600px" id="djs-body-click">
  <div class="header"></div>
  <SideNav></SideNav>
  <div id="djs-content-container" style="margin: 1rem 1rem 1rem 75px">
    <AssignHours></AssignHours>
    <!--
    <Salary></Salary>
  -->
  </div>
</div>
</template>

<script>
import SideNav from './SideNav'
import Salary from './Salary/Salary.vue'
import Supplements from './Supplements/Supplements.vue'
import AssignHours from './AssignHours/AssignHours.vue'
export default {
  components: {
    Salary,
    Supplements,
    SideNav,
    AssignHours
  }
}
</script>

<style scoped>
@import "../assets/css/variables.css";

.box {
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.07);
  background: #fff;
  padding: 20px;
  border-radius: 4px;
}

.header {
  display: flex;
  justify-content: flex-end;
  align-items: stretch;
  padding-right: 100px;
  background: white;
  position: relative;
  z-index: 130;
  width: 100%;
  max-width: 100%;
  height: 55px;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);
}

.content {
  background: #edf0f5;
  padding: 20px 20px 20px 65px;
}

.sidebar {
  background-color: #3e4450;
  margin: 0;
  position: fixed;
  top: 0;
  left: 0;
  min-height: 100%;
  width: 65px;
  z-index: 810;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
}

.playground {
  margin-left: 250px;
}

.header-nav__item {
  display: flex;
  cursor: pointer;
  padding: 0 20px;
  margin: 0;
  align-items: center;
  font-size: 11px;
  text-transform: uppercase;
  color: rgba(62, 68, 80, 0.7);
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// Show.vue?7f94c7eb